module.exports = __webpack_public_path__ + "img/tooltip.405918ce.svg";